import React from "react";
import { useIntl } from "react-intl";
import { Grid, Box, Typography, Divider } from "@mui/material";
import { Input } from "Components";
import { Switch } from "@gpstrackit/gtc-react-controls";

const PasswordDriverFields = ({
  formData,
  setFormData,
  isRequiredUsername = false,
  isRequiredPwd = false,
  hideHeader = false,
  errorMatchPassword,
  setErrorMatchPassword,
}) => {
  const { messages } = useIntl();

  return (
    <>
      {!hideHeader && (
        <>
          <Box mt="10px">
            <Typography variant="subtitle2" component="h6">
              {messages["settingsDriver_fsmLogin"]}
            </Typography>
          </Box>
          <Box mt={1}>
            <Divider />
          </Box>
        </>
      )}

      <Grid mt="5px">
        <Box mt={1} mb={1}>
          <Typography variant="subtitle2" color="textSecondary">
            {messages["settingsDriver_fmsLoginMessage"]}
          </Typography>
        </Box>
        <Box>
          <Input
            id="username"
            type="text"
            label={messages["settingsDriver_username"]}
            placeholder={messages["settingsDriver_username"]}
            value={formData?.username || ""}
            onChange={(value) => {
              setFormData({
                ...formData,
                username: value,
                password: value?.length > 0 ? formData?.password : null,
                repeatPassword:
                  value?.length > 0 ? formData?.repeatPassword : null,
              });
            }}
            required={isRequiredUsername}
            requiredMessage={messages["settingsDriver_fmsLoginPwdRequired"]}
            regex={/^[A-Za-z0-9]*$/}
            handleKeyDown={32}
            minLength={4}
            minLengthMessage={`${messages["settingsDriver_minLengthMessageName"]} 4`}
            maxLength={12}
            maxLengthMessage={`${messages["settingsDriver_maxLengthMessageName"]} 12`}
          />
        </Box>
      </Grid>
      <Grid mt="5px">
        <Input
          id="password"
          type="password"
          label={messages["settingsDriver_password"]}
          placeholder={messages["settingsDriver_password"]}
          value={formData?.password || ""}
          onChange={(value) => {
            setFormData({ ...formData, password: value });
          }}
          disabled={!formData?.username ? true : false}
          minLength={6}
          minLengthMessage={`${messages["settingsDriver_minLengthMessagePassword"]} 6`}
          maxLength={30}
          required={isRequiredPwd != formData?.username && formData?.username}
          requiredMessage={messages["settingsDriver_fmsLoginPwdRequired"]}
          maxLengthMessage={`${messages["settingsDriver_maxLengthMessagePassword"]} 30`}
        />
      </Grid>
      <Grid mt="5px">
        <Input
          id="repeatPassword"
          type="password"
          disabled={!formData?.username ? true : false}
          label={messages["settingsDriver_repeatPassword"]}
          placeholder={messages["settingsDriver_repeatPassword"]}
          value={formData?.repeatPassword || ""}
          onChange={(value) => {
            setFormData({ ...formData, repeatPassword: value });
            setErrorMatchPassword && setErrorMatchPassword(null);
          }}
          minLength={6}
          maxLength={30}
          required={formData?.password !== formData?.repeatPassword}
          requiredMessage={messages["settingsDriver_repeatPasswordDoNotMatch"]}
        />
      </Grid>
      <Grid mt="5px">
        <Box mt={2}>
          <Switch
            optionLabels={[
              messages["settingsDriver_yes"],
              messages["settingsDriver_no"],
            ]}
            label={messages['settingsDriver_hasVideoAccess']}
            size="medium"
            checked={formData?.hasVideoAccess}
            onChange={() =>
              setFormData({
                ...formData,
                hasVideoAccess: !formData?.hasVideoAccess,
              })
            }
          />
        </Box>
      </Grid>
      {errorMatchPassword && (
        <small
          className="select-error text-danger"
        >
          {errorMatchPassword}
        </small>
      )}
    </>
  );
};

export default PasswordDriverFields;
